/**
 * Custom Next.js image loader.
 *
 * - R2 images (img.finda.show): serve pre-generated WebP variants
 * - External images: fall through to default (Vercel /_next/image proxy)
 */

import { getVariantUrl } from "./image-variant-urls";

const R2_HOST = "img.finda.show";

interface ImageLoaderParams {
  src: string;
  width: number;
  quality?: number;
}

export default function imageLoader({ src, width, quality: _quality }: ImageLoaderParams): string {
  // R2 images → pre-generated variants
  if (src.includes(R2_HOST)) {
    return getVariantUrl(src, width);
  }

  // Legacy Supabase images (during migration) → variant via R2
  if (src.includes("/storage/v1/object/public/images/")) {
    const match = src.match(/\/storage\/v1\/object\/public\/images\/(.+)$/);
    if (match) {
      return getVariantUrl(`https://${R2_HOST}/${match[1]}`, width);
    }
  }

  // Never load external images — return transparent pixel
  console.warn(`[image-loader] Blocked external image: ${src}`);
  return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
}
